var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "projects-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [_vm._v("Группировка")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "groups-container" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.selectedGroupID))]
          ),
          _vm._v(" "),
          _vm._l(_vm.planeGroupList, function(group, key) {
            return _c(
              "div",
              {
                staticClass: "groups-grid",
                on: {
                  click: function($event) {
                    return _vm.selectGroup(key)
                  },
                  dblclick: function($event) {
                    return _vm.editSelectedGroup(key)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "groups-grid-element",
                  style: {
                    "background-color": group.color,
                    width: _vm.colorFieldWidth(key)
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "groups-grid-element",
                    style: {
                      color: _vm.groupNameColor(key)
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(group.name) +
                        "\n            "
                    )
                  ]
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "add-group-button",
          on: {
            click: function($event) {
              return _vm.addPlaneGroup()
            }
          }
        },
        [_vm._v("\n        + Добавить группу\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }